module.exports = __webpack_public_path__ + "img/ddd.6854d660.png";